//#region Libraries
//#endregion
//#region Styles
//#endregion
//#region Components
import { Container } from "./styles";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const DefinitionAcadReinforceType = ({
    icon, title, 
    description
}) => {
    return (
        <Container>
            <img 
                src={icon.replace(".svg", "_def.svg")} 
                alt={title}/>
            <span>
                <strong>{title}: </strong>
                {description}
            </span>
        </Container>
    );
}

export default DefinitionAcadReinforceType;